import { Outlet } from "react-router-dom";
import "../styles/layouts.css";

// MapLayout is a special layout only for the Map page.
// It intentionally hides the navbar so the map has maximum space and feels like a focused tool.
// Example:
// - When you visit `/map`, only the map UI is shown (no top menu).
function MapLayout() {
  return (
    <div className="app-shell app-shell--map">
      {/* Outlet:
          This is where the Map page will be placed.
          Example: when the URL is `/map`, <MapPage /> appears here. */}
      <Outlet />
    </div>
  );
}

export default MapLayout;

